// @flow
/* eslint-disable import/prefer-default-export */
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { CustomerField } from 'types/customerField'

export async function getCustomerFields(
  requestParams: { signal?: AbortSignal } = {}
): Promise<CustomerField[]> {
  return await makeGetRequest(ApiBase + '/customer_fields', requestParams)
}
